import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '@environments/environment';
import {ListOpeCarte} from "@domain/opecarte/list-opecarte";

@Injectable()
export class OpeCarteService {
    /**
     * Constructor
     * @param http 	httpClient
     */
    constructor(private http: HttpClient) {
    }

    /**
     * Récupère les données de OpeCarte.
     * @returns Un Observable contenant les données opeCarte
     */
    getData(): Observable<ListOpeCarte> {
        return this.http.get<ListOpeCarte>(`${environment.baseUrl}/controller/OpeCarte/listeCarte`);
    }

    /**
     * Sauvegarde des opérations cartes au statut Archivé
     * @param listeOpeCarteIds  Liste des opérations cartes
     * @param userId            ID de l'utilisateur à qui appartient les opérations cartes
     * @returns Le résultat de la sauvegarde
     */
    saveArchive(listeOpeCarteIds: any, userId: number): Observable<any> {
        //Récupérer les IDs des opérations cartes avant la sauvegarde
        const ids = listeOpeCarteIds.map(item => item.idOpeCarte);
        return this.http.post<any>(`${environment.baseUrl}/controller/OpeCarte/moveOpCarteListeArchives/${userId}`, ids);
    }

    /**
     * Sauvegarde des opérations cartes en dépense personnelle
     * @param listeOpeCarteIds  Liste des opérations cartes
     * @param userId            ID de l'utilisateur à qui appartient les opérations cartes
     * @returns Le résultat de la sauvegarde
     */
    moveOpeCarteDepPerso(listeOpeCarteIds: any, userId: number): Observable<any> {
        //Récupérer les IDs des opérations cartes avant la sauvegarde
        const ids = listeOpeCarteIds.map(item => item.idOpeCarte);
        return this.http.post<any>(`${environment.baseUrl}/controller/OpeCarte/moveOpCarteListeDepPerso/${userId}`, ids);
    }

    /**
     * Sauvegarde des opérations cartes en attente
     * @param listeOpeCarteIds  Liste des opérations cartes
     * @param userId            ID de l'utilisateur à qui appartient les opérations cartes
     * @returns Le résultat de la sauvegarde
     */
    moveOpCarteEnAttente(listeOpeCarteIds: any, userId: number): Observable<any> {
        //Récupérer les IDs des opérations cartes avant la sauvegarde
        const ids = listeOpeCarteIds.map(item => item.idOpeCarte);
        return this.http.post<any>(`${environment.baseUrl}/controller/OpeCarte/moveOpCarteEnAttente/${userId}`, ids);
    }
}
